<template>
  <section class="cipe">
    <div v-if="value && value.length" class="cipe__selected">
      <CRFilterTag
        v-for="(result, index) in value"
        :key="index"
        :label="result.description"
        @click="handleRemoveCipe(result)"
      />
    </div>
    <div v-if="loading" class="cipe__label">
      <WLabel class="cipe__label">Carregando CIPEs</WLabel>
      <WIcon icon="icLoad" />
    </div>
    <CRPopupContainer v-else-if="cipes && cipes.length">
      <div class="cipe__label">
        <div>Adicionar CIPE</div>
        <WIcon icon="icChevronArrowDown" />
      </div>

      <template #content>
        <CRDropdownMenu
          label-key="description"
          :value="value"
          suggestion-list-title="CIPEs sugeridos"
          :suggestion-list="cipes"
          @input="handleAddCipe"
          @remove="handleRemoveCipe"
        />
      </template>
    </CRPopupContainer>
    <div v-else class="cipe__label">Nenhum CIPE encontrado</div>
  </section>
</template>
<script>
import { WIcon, WLabel } from '@alice-health/wonderland-vue'

import CRDropdownMenu from '@/components/clinicalRecord/atoms/CRDropdownMenu.vue'
import CRFilterTag from '@/components/clinicalRecord/atoms/CRFilterTag.vue'
import CRPopupContainer from '@/components/clinicalRecord/atoms/CRPopupContainer.vue'

export default {
  components: {
    WIcon,
    WLabel,
    CRPopupContainer,
    CRDropdownMenu,
    CRFilterTag
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    cipes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean
    }
  },
  emits: ['input'],
  methods: {
    handleAddCipe(value) {
      if (this.value?.find(cipe => cipe.id === value.id)) {
        return
      }
      const result = !this.value ? [value] : [...this.value, value]
      this.$emit('input', result)
    },
    handleRemoveCipe(value) {
      const array = [...this.value]
      const index = array.findIndex(item => item.id === value.id)
      array.splice(index, 1)
      this.$emit('input', array)
    }
  }
}
</script>
<style lang="scss" scoped>
.cipe {
  &__label {
    display: flex;
    color: var(--sys-color-content-secondary);
    align-items: center;
    gap: var(--gl-spacing-02);

    cursor: pointer;
  }
  &__selected {
    gap: var(--gl-spacing-02);
    display: flex;
    flex-wrap: wrap;
    margin-bottom: var(--gl-spacing-04);
  }
}
</style>
